import React from 'react';

export const SmallerBlueArrow = ({ children }) => (
  <div className="relative inline">
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute -right-5 -top-14 invisible sm:visible"
    >
      <path
        d="M19.8998 9.22179e-06L0 19.9019H45.1001V65L64.9999 45.0981L65 0L19.8998 9.22179e-06Z"
        fill="#4BADE4"
      />
    </svg>
    <svg
      width="35"
      height="36"
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute -right-1 -top-7 visible sm:invisible"
    >
      <path
        d="M10.7153 0.77979L0 11.4962H24.2847V35.7798L35 25.0634L35 0.779785L10.7153 0.77979Z"
        fill="#4BADE4"
      />
    </svg>
    {children}
  </div>
);

export const SmallBlueArrow = ({ children }) => (
  <div className="relative">
    <svg
      width="112"
      height="112"
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="z-10 absolute -right-5 -top-5"
    >
      <path
        d="M34.2889 1.68339e-05L0 34.2926H77.711V112L112 77.7075L112 0L34.2889 1.68339e-05Z"
        fill="#4BADE4"
      />
    </svg>
    {children}
  </div>
);

export const SmallGreenArrow = ({ children }) => (
  <div className="relative z-10">
    <svg
      width="112"
      height="112"
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="z-10 absolute -right-5 -top-5 invisible sm:visible"
    >
      <path
        d="M34.2889 1.68339e-05L0 34.2926H77.711V112L112 77.7075L112 0L34.2889 1.68339e-05Z"
        fill="#64D09C"
      />
    </svg>
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="z-10 absolute -right-1 -top-1 visible sm:invisible"
    >
      <path
        d="M10.7153 4.96558e-06L0 10.7164H24.2847V35L35 24.2836L35 0L10.7153 4.96558e-06Z"
        fill="#64D09C"
      />
    </svg>
    {children}
  </div>
);

export const LargeYellowArrow = ({ children, ...props }) => (
  <div className="relative" {...props}>
    <svg
      width="169"
      height="169"
      viewBox="0 0 169 169"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="z-10 absolute -right-5 -top-5 group-hover:-right-10 group-hover:-top-10 transition-all duration-200 ease-in-out"
    >
      <path d="M168 0H42L0 42H126V168L168 126V0Z" fill="#FEDC6B" />
    </svg>
    {children}
  </div>
);
